export enum CmsCollectionSchemaDataTypeEnum {
  Text = 1,
  Number = 2,
  Select = 3,
  Ref = 4,
  CodeEditor = 5,
}
